import { defineMessages } from 'react-intl';

export const workChatNotFoundMessages = defineMessages({
  title: {
    defaultMessage: 'Project not found',
    id: 'HgWvUilzG4',
    description: 'Work chat empty state when the project id does not resolve',
  },
  description: {
    defaultMessage:
      "This project may have been deleted, or the Projects API isn't deployed yet.",
    id: 'SIuNr4mSPl',
    description: 'Work chat empty state explanation for a missing project',
  },
  revokedTitle: {
    defaultMessage: 'Access to this thread was removed',
    id: 'k3ygNuGSv8',
    description: 'Work chat empty state when a shared project grant has been revoked',
  },
  revokedDescription: {
    defaultMessage: 'The owner stopped sharing this Work thread with you.',
    id: 'N1eOgysetb',
    description: 'Explanation under the revoked shared-thread empty state',
  },
});
